import { Section, Center, Row, Col } from '@styled/global';
import styled from 'vue-styled-components';
import { boxShadow } from 'styled-system';

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n   padding: 10px;\n   text-align: center;\n\n   & a {\n      color: ", ";\n\n      &:hover {\n         text-decoration: underline;\n      }\n   }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n   ", "\n\n   border-radius: 10px;\n   padding: 20px;\n   width: 100%;\n   height: 100%;\n   margin: 20px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n   color: ", ";\n   font-size: 18px;\n   margin-bottom: 10px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n   width: 70%;\n   max-width: 237px;\n   margin: auto;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n   color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n   color: ", ";\n   font-size: 28px;\n   margin: 40px 0 20px 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var Title = styled("h2", {})(_templateObject(), function (props) {
  return props.theme.secondaryColor;
});
var Subtitle = styled("p", {})(_templateObject2(), function (props) {
  return props.theme.primaryColor;
});
var Image = styled("img", {})(_templateObject3());
var TileHeading = styled("h3", {})(_templateObject4(), function (props) {
  return props.theme.secondaryColor;
});
var Panel = styled("div", {
  boxShadow: {
    default: function _default() {
      return ["0px 0px 10px #d3d3d3", "0px 0px 10px #d3d3d3", "none"];
    },
    type: [Number, String, Object, Array]
  }
})(_templateObject5(), boxShadow);
var Body = styled("div", {})(_templateObject6(), function (props) {
  return props.theme.secondaryColor;
});

// Application imports
var script = {
  props: {
    copy: {
      required: true,
      type: Object
    }
  },
  render: function render() {
    var h = arguments[0];

    var renderPanels = function renderPanels(panels) {
      return panels.map(function (panel, panelIndex) {
        return h(Panel, [h(TileHeading, [panel.title]), h(Body, {
          "domProps": {
            "innerHTML": panel.body
          }
        })]);
      });
    };

    return h(Section, {
      "attrs": {
        "mt": "-10px"
      }
    }, [h(Center, {
      "attrs": {
        "flexDirection": "column"
      }
    }, [h(Row, [h(Col, {
      "attrs": {
        "width": [12]
      }
    }, [h(Title, [this.copy.title]), h(Subtitle, [this.copy.subtitle])])]), h(Row, [h(Col, {
      "attrs": {
        "width": [12, 12, 4]
      }
    }, [renderPanels(this.copy.left)]), h(Col, {
      "attrs": {
        "display": ["none", "none", "flex"],
        "width": [12, 12, 4],
        "alignItems": "center"
      }
    }, [h(Image, {
      "attrs": {
        "src": this.copy.image.url,
        "alt": this.copy.image.alt
      }
    })]), h(Col, {
      "attrs": {
        "width": [12, 12, 4]
      }
    }, [renderPanels(this.copy.right)])])])]);
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

/* script */
const __vue_script__ = script;

/* template */

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = normalizeComponent(
    {},
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
